/* ChewNectar gummy finder. One question per screen, email gate, then the report.
   Answers survive the Shopify customer-form redirect through sessionStorage. */
(() => {
  const root = document.querySelector('[data-quiz]');
  if (!root) return;

  const KEY = 'cn-quiz-' + (root.dataset.quizId || 'default');
  const steps = [...root.querySelectorAll('[data-step]')];
  const bar = root.querySelector('[data-quiz-bar]');
  const countEl = root.querySelector('[data-quiz-count]');
  const results = [...root.querySelectorAll('[data-result]')];
  const reportStep = steps.findIndex((s) => s.dataset.step === 'report');
  const questionCount = steps.filter((s) => s.dataset.step === 'q').length;

  let answers = {};
  try { answers = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { answers = {}; }
  const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(answers)); } catch (e) {} };

  let i = 0;
  let touched = false;
  const show = (n) => {
    i = Math.max(0, Math.min(steps.length - 1, n));
    steps.forEach((s, k) => s.classList.toggle('is-on', k === i));
    const done = steps.slice(0, i).filter((s) => s.dataset.step === 'q').length;
    const pct = i >= reportStep ? 100 : Math.round((done / (questionCount + 1)) * 100);
    if (bar) bar.style.width = pct + '%';
    if (countEl) {
      countEl.textContent = i >= reportStep
        ? (countEl.dataset.done || 'Your result')
        : 'Step ' + Math.min(done + 1, questionCount + 1) + ' of ' + (questionCount + 1);
    }
    const h = steps[i].querySelector('.quiz__q');
    if (h) {
      h.setAttribute('tabindex', '-1');
      if (touched) h.focus({ preventScroll: true });
    }
    touched = true;
  };

  root.querySelectorAll('.qopt').forEach((btn) => {
    const step = btn.closest('[data-step]');
    const key = step.dataset.key;
    if (answers[key] === btn.dataset.value) btn.setAttribute('aria-pressed', 'true');
    btn.addEventListener('click', () => {
      answers[key] = btn.dataset.value;
      answers[key + '_label'] = btn.dataset.label || btn.textContent.trim();
      save();
      step.querySelectorAll('.qopt').forEach((x) => x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'));
      window.setTimeout(() => show(i + 1), 220);
    });
  });

  root.querySelectorAll('[data-quiz-back]').forEach((b) => b.addEventListener('click', () => show(i - 1)));

  const tagInput = root.querySelector('[data-quiz-tags]');
  const emailForm = root.querySelector('[data-quiz-form]') || root.querySelector('form');
  if (emailForm && tagInput) {
    emailForm.addEventListener('submit', () => {
      const base = tagInput.dataset.base || 'quiz-lead';
      const need = answers.need ? 'quiz-' + answers.need : '';
      const level = answers.level ? 'quiz-' + answers.level : '';
      tagInput.value = [base, need, level].filter(Boolean).join(',');
      answers.submitted = true;
      save();
    });
  }

  const fill = () => {
    const need = answers.need;
    const chosen = results.find((r) => r.dataset.result === need) || results[0];
    results.forEach((r) => { r.hidden = r !== chosen; });
    root.querySelectorAll('[data-echo]').forEach((el) => {
      const k = el.dataset.echo;
      el.textContent = answers[k + '_label'] || '';
      const wrap = el.closest('[data-echo-row]');
      if (wrap) wrap.hidden = !answers[k + '_label'];
    });
    root.querySelectorAll('[data-level-only]').forEach((el) => {
      el.hidden = el.dataset.levelOnly !== answers.level;
    });
  };

  const params = new URLSearchParams(window.location.search);
  const posted = params.get('customer_posted') === 'true';
  const forced = root.dataset.start
    ? steps.findIndex((s) => s.dataset.step === root.dataset.start)
    : -1;

  if (posted && answers.need) {
    fill();
    show(reportStep);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else if (forced > -1) {
    show(forced);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    show(0);
  }

  root.querySelectorAll('[data-quiz-restart]').forEach((b) => b.addEventListener('click', () => {
    answers = {};
    save();
    root.querySelectorAll('.qopt').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    show(0);
  }));
})();
